import { Controller } from "@hotwired/stimulus";
import { seemsOffline, visit } from "../../../../utils/connectivity";
import { isPwaEnabled } from "../../../../utils/offline_gating";
import {
  quizQuestionUrl,
  welcomeOfflineStartUrl,
  cacheQuizUrl,
  isQuizUrlCached,
} from "../../../../utils/quiz_offline_cache";

export default class extends Controller {
  static values = { quizId: Number, totalQuestions: Number };
  static outlets = ["offline-navigation"];

  connect() {
    if (!isPwaEnabled()) return;
    if (seemsOffline()) return;
    this.seedCache();
  }

  async seedCache() {
    if (!this.quizIdValue || !this.totalQuestionsValue) return;

    const urls = [];
    for (let i = 1; i <= this.totalQuestionsValue; i++) {
      urls.push(quizQuestionUrl(this.quizIdValue, i, { mode: "study" }));
      urls.push(quizQuestionUrl(this.quizIdValue, i, { mode: "quiz" }));
    }

    await Promise.all(
      urls.map(async (url) => {
        if (await isQuizUrlCached(url)) return;
        await cacheQuizUrl(url);
      }),
    );
  }

  async guard(event) {
    if (!seemsOffline()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const trigger = event.currentTarget;
    const checked = this.element.querySelector('input[name="mode"]:checked');
    if (!checked) {
      const modeMsg = document.getElementById("modeMsg");
      if (modeMsg) {
        modeMsg.innerText = "Please select one mode to continue";
      }
      return;
    }

    const firstIndex =
      trigger.getAttribute("data-first-index") ||
      document.getElementById("start-button")?.getAttribute("data-first-index") ||
      "1";
    const firstUrl = welcomeOfflineStartUrl(
      this.quizIdValue,
      firstIndex,
      checked.value,
    );
    if (firstUrl && (await isQuizUrlCached(firstUrl))) {
      if (this.hasOfflineNavigationOutlet) {
        this.offlineNavigationOutlet.showStudyModeNotice(firstUrl, trigger);
      } else {
        visit(firstUrl);
      }
      return;
    }
    if (this.hasOfflineNavigationOutlet) {
      this.offlineNavigationOutlet.showFeatureUnavailable(trigger);
    }
  }
}
